import { Record, List, fromJS } from 'immutable';
import CurrencyUtilities from 'records/CurrencyUtilities';

const contentFileList = [
  {
    id: 0,
    contentUrl: '',
    contentName: '',
    description: '',
    createTime: null,
    createBy: 0,
  },
];

const defaultValues = {
  id: null,
  recipeCategoryId: null,
  userCategoryId: null,
  brandId: null,
  foodTypeId: null,
  recipeName: '',
  description: '',
  note: '',
  course: '',
  costPerPortion: 0,
  costPerServing: 0,
  costPerRecipe: 0,
  yield: 0,
  yieldUnits: 'oz',
  seasonOrOccasion: '',
  servingUnits: 'oz',
  servings: 0,
  defaultPrice: 0,
  prepTimeMinutes: 0,
  cookTimeMinutes: 0,
  hasIngredients: false,
  hasDirections: false,
  isFromSysco: false,
  archived: false,
  created: null,
  createdBy: null,
  updated: null,
  updatedBy: null,
  file: null,
  contentFileList: fromJS(contentFileList),
  batchlevel: null,
  isBatchRecipe: false,
  timesUsed: null,
  usedInRecipes: new List(),
  lastModifiedBy: null,
  visible: false,
  lockedByOther: false,
  lockedByOtherName: null,
  visibleAccess: false,
  price: 0,
  profit: 0,
  costPercent: 0,
  usedInMenus: new List(),
  error: null
};

export default class Recipe extends Record(defaultValues, Recipe) {
  constructor(values) {
    super({
      ...values,
      contentFileList: values && values.contentFileList
                        ? fromJS(values.contentFileList)
                        : defaultValues.contentFileList,
      costPerPortion: values && values.costPerPortion
                      ? CurrencyUtilities.currencyFormat(values.costPerPortion)
                      : defaultValues.costPerPortion,
      costPerServing: values && values.costPerServing
                      ? CurrencyUtilities.currencyFormat(values.costPerServing)
                      : defaultValues.costPerServing,
      costPerRecipe: values && values.costPerRecipe
                      ? CurrencyUtilities.currencyFormat(values.costPerRecipe)
                      : defaultValues.costPerRecipe,
      usedInMenus: values && values.usedInMenus ? fromJS(values.usedInMenus) : defaultValues.usedInMenus,
    });
  }

  static getActiveRecipes(recipes) {
    return recipes.filter((recipe) => {
      return recipe.get('archived') === false;
    });
  }

  static getArchivedRecipes(recipes) {
    return recipes.filter((recipe) => {
      return recipe.get('archived') === true;
    });
  }

  static getRecipeIndexById(recipes, id) {
    return recipes.findIndex(item => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static updateRecipeByIndex(recipes, index, recipe) {
    return recipes.set(index, recipe);
  }

  static filterByRecipeCategoryId(recipes, id) {
    return recipes.filter((recipe) => {
      return recipe.get('userCategoryId') === id;
    });
  }

  static removeByRecipeCategoryId(recipes, id) {
    return recipes.filter((recipe) => {
      return recipe.get('userCategoryId') !== id;
    });
  }

  static getRecipeById(recipes, id) {
    return recipes.find((recipe) => {
      return recipe.get('id') == id ? recipe : undefined;
    });
  }

  static mergeRecipesById(oldRecipes, newRecipes) {
    let recipesData = oldRecipes;
    newRecipes.forEach((item) => {
      const itemIndex = Recipe.getRecipeIndexById(recipesData, item.get('id'));
      if (itemIndex >= 0) {
        recipesData = Recipe.updateRecipeByIndex(recipesData, itemIndex, item);
      } else {
        recipesData = recipesData.push(item);
      }
    });
    return recipesData;
  }

  static mergeRecipesCategoryByCategoryId(oldRecipes, newRecipes, userCategoryId) {
    const categoryId = userCategoryId;
    let recipesData = oldRecipes;
    recipesData = Recipe.removeByRecipeCategoryId(recipesData, categoryId);

    if( newRecipes.size > 0 ) {
      const sortedNewRecipes = newRecipes.sort((itemOne, itemTwo) => {
        if (itemOne.get('updated') > itemTwo.get('updated')) return -1;
        if (itemOne.get('updated') < itemTwo.get('updated')) return 1;
        return 0;
      });
      recipesData = recipesData.concat(sortedNewRecipes);
    }
    return recipesData;
  }

  static filterRecipeForEndecaSearch(recipes, keywords, filteredId) {
    let keywordsUpper = keywords ? keywords.toUpperCase() : null;
    return recipes.filter((recipe) => {
      return (recipe.get('recipeName').toUpperCase().includes(keywordsUpper)
        || recipe.get('note').toUpperCase().includes(keywordsUpper))
        && recipe.get('id') !== filteredId
        && recipe.get('yield') !== 0
        && !recipe.get('archived');
    })
  }

  static filterBatchRecipeByRecipeName(batchRecipes, keywords) {
    let keywordsUpper = keywords.trim().toUpperCase();
    return batchRecipes.filter((batchRecipe) => {
      return batchRecipe.get('recipeName') && batchRecipe.get('recipeName').trim().toUpperCase().includes(keywordsUpper);
    });
  }

  static filterRecipesByRecipeName(recipes, keywords) {
    let keywordsUpper = keywords ? keywords.trim().toUpperCase() : null;
    return recipes.filter((recipe) => {
      return recipe.get('recipeName') && recipe.get('recipeName').trim().toUpperCase().includes(keywordsUpper);
    });
  }

  static filterRecipeById(recipes, id) {
    return recipes.filter((recipe) => {
      return recipe.get('id') == id;
    });
  }

  static getVisibleRecipes(recipes) {
    return recipes.filter((recipe) => {
      return recipe.get('visible') === true;
    });
  }

  static filterRecipesByName(recipes, keywords) {
    let keywordsUpper = keywords.toUpperCase();
    return recipes.filter((recipe) => {
      return recipe.get('recipeName') && recipe.get('recipeName').toUpperCase().includes(keywordsUpper);
    });
  }
}

export const Recipes = (data) => {
  let recipes = new List();
  if (data) {
    data.forEach((value) => {
      recipes = recipes.push(new Recipe(value));
    });
  }
  return recipes;
};
